import React from 'react';
import { Box, keyframes } from '@mui/material';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

interface InlineLoaderProps {
  size?: number;
  color?: string;
}

const InlineLoader: React.FC<InlineLoaderProps> = ({ 
  size = 20, 
  color = 'inherit' 
}) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        position: 'relative',
      }}
    >
      <Box
        component="img"
        src="/logo192.png"
        alt=""
        sx={{
          width: size * 0.7,
          height: size * 0.7,
          objectFit: 'contain',
          animation: `${pulse} 1.5s ease-in-out infinite`,
          filter: color === 'inherit' ? 'inherit' : undefined,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          border: `2px solid`,
          borderColor: 'divider',
          borderTopColor: color === 'inherit' ? 'primary.main' : color,
          borderRadius: '50%',
          animation: `${spin} 1s linear infinite`,
        }}
      />
    </Box>
  );
};

export default InlineLoader;